import {FC} from 'react'
import {Helmet} from 'react-helmet-async'
import {useIntl} from 'react-intl'
import {KTIcon, toAbsoluteUrl} from '../../../_metronic/helpers'

const Terms: FC = () => {
  const intl = useIntl()
  return (
    <>
      <Helmet>
        <title>{intl.formatMessage({id: 'TERMS.META.TITLE'})}</title>
        <meta name='description' content={intl.formatMessage({id: 'TERMS.META.DESC'})} />
        <meta property='og:title' content={intl.formatMessage({id: 'TERMS.META.TITLE'})} />
        <meta property='og:description' content={intl.formatMessage({id: 'TERMS.META.DESC'})} />
      </Helmet>

      {/* Hero Section */}
      <section className='hero-section contact-hero mt-2'>
        <div className='hero-content'>
          <div className='mb-4'>
            <span className='badge px-4 py-2 rounded-pill'>
              <KTIcon iconName='document' className='fs-2 text-warning ms-2' />
              {intl.formatMessage({id: 'TERMS.HERO.BADGE'})}
            </span>
          </div>
          <h1 className='hero-title'>
            {intl.formatMessage({id: 'TERMS.HERO.TITLE'})}
            <br />
            {intl.formatMessage({id: 'TERMS.HERO.SUBTITLE'})}
          </h1>
          <p className='hero-desc'>
            {intl.formatMessage({id: 'TERMS.HERO.DESC'})}
          </p>
        </div>
        <div className='hero-image'>
          <img
            src={toAbsoluteUrl('/media/illustrations/energy/Img_About_1.webp')}
            alt={intl.formatMessage({id: 'TERMS.HERO.BADGE'})}
          />
        </div>
        <button
          className='hero-scroll-btn'
          onClick={() => {
            const nextSection = document.getElementById('first-content-section')
            if (nextSection) nextSection.scrollIntoView({behavior: 'smooth'})
          }}
          aria-label={intl.formatMessage({id: 'COMMON.SCROLL_DOWN'})}
        >
          <svg
            className='hero-scroll-svg'
            width='120'
            height='64'
            viewBox='0 0 120 64'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
          >
            <path
              d='M88.0935 28C88.0935 12.536 75.3811 0 59.6996 0C44.0181 0 31.3057 12.536 31.3057 28C31.3057 43.464 44.0181 56 59.6996 56C75.3811 56 88.0935 43.464 88.0935 28Z'
              fill='#F1F1F3'
            ></path>
            <path
              d='M39.5969 8.86421C32.3121 15.6129 24.4015 27.5594 4.6961 27.8366C-15.0093 28.1137 33.673 39.7129 33.673 39.7129C33.673 39.7129 46.8818 2.11406 39.5969 8.86421Z'
              fill='#F1F1F3'
            ></path>
            <path
              d='M80.4024 8.86412C86.625 16.1764 95.5975 27.5595 115.304 27.8366C135.01 28.1138 86.3273 39.7129 86.3273 39.7129C86.3273 39.7129 74.1798 1.55253 80.4024 8.86412Z'
              fill='#F1F1F3'
            ></path>
            <path
              d='M54.6667 22.3334L60 27.6667L65.3334 22.3334'
              stroke='#19191A'
              strokeWidth='2'
              strokeLinecap='round'
              strokeLinejoin='round'
            ></path>
          </svg>
        </button>
      </section>

      {/* Terms Content */}
      <section id='first-content-section' className='py-20'>
        <div className='container'>
          <div className='row justify-content-center'>
            <div className='col-lg-8 col-xl-7'>
              <div className='card shadow-sm border-0' style={{borderRadius: '24px'}}>
                <div className='card-body p-5 p-md-6'>
                  <ul
                    dir={intl.locale === 'ar' || intl.locale === 'fa' ? 'rtl' : 'ltr'}
                    style={{fontSize: '1.15rem'}}
                    className='list-unstyled text-gray-800'
                  >
                    <li className='mb-3'>{intl.formatMessage({id: 'TERMS.T1'})}</li>
                    <li className='mb-3'>{intl.formatMessage({id: 'TERMS.T2'})}</li>
                    <li className='mb-3'>{intl.formatMessage({id: 'TERMS.T3'})}</li>
                    <li className='mb-3'>{intl.formatMessage({id: 'TERMS.T4'})}</li>
                    <li className='mb-3'>{intl.formatMessage({id: 'TERMS.T5'})}</li>
                    <li className='mb-3'>{intl.formatMessage({id: 'TERMS.T6'})}</li>
                    <li className='mb-3'>{intl.formatMessage({id: 'TERMS.T7'})}</li>
                    <li className='mb-3'>{intl.formatMessage({id: 'TERMS.T8'})}</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
export {Terms}
